(()=>{
 class SPDetailGallery extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;this.dialog=this.querySelector('dialog');if(typeof this.dialog?.showModal!=='function')return;
   this.controller=new AbortController();const opts={signal:this.controller.signal};this.buttons=this.querySelectorAll('[data-sp-detail]');this.buttons.forEach(b=>b.hidden=false);
   this.addEventListener('click',event=>{
    const button=event.target.closest('[data-sp-detail]');if(!button)return;
    this.trigger=button;const photo=this.querySelector('[data-detail-image]');photo.src=button.dataset.src;photo.alt=button.dataset.title||'';this.querySelector('[data-detail-title]').textContent=button.dataset.title||'DETALLE';this.dialog.showModal();
   },opts);
   this.querySelector('[data-detail-close]').addEventListener('click',()=>this.dialog.close(),opts);
   this.dialog.addEventListener('close',()=>{if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});},opts);
   this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();},opts);
  }
  disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.controller=null;}
 }
 if(!customElements.get('sp-detail-gallery'))customElements.define('sp-detail-gallery',SPDetailGallery);
})();
